import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="ASPE OS BILHETES E OBTENHA O SEU BÔNUS"
            highlights={[
                { word: 'OBTENHA' },
                { word: 'O SEU' },
                { word: 'BÔNUS' },
            ]}
            breakBeforeWords={['OBTENHA']}
            className={styles.text_header}
        />
    )
}
